<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Purchase Adjustment</h1>
        </div>

        <div class="ppl-container">
            <div class="ppl-content-container">

                <!-- Filter + Notes -->
                <div class="w-100">
                    <ppl-purchase-filter [pageId]="pageId" (searchEvent)="onSearch($event)">
                    </ppl-purchase-filter>

                    <p class="pl-2">
                        <span class="error-message1">*</span>
                        At least one out of the following fields should be populated:
                        <b>Participant Name</b>, <b>Participant PPL ID</b>.
                    </p>

                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Adjust</strong> and <strong>Void</strong> actions, please select the
                                applicable purchase.</li>
                        </ul>
                    </div>
                </div>

                <!-- Data Table -->
                <div class="table-style">
                    @if (purchases.length > 0) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="purchases" [customDataLoaded]="true" [enableActions]="true" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly" [timesheetFor]="'pendedTimesheet'"
                        (onPageLoad)="onPageLoad($event)"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)"
                        (gridAction)="onAction($event)"
                        (rowCellClicked)="onCellClicked($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">
                        <strong>No Records Found.</strong> Please change the filters to find the records.
                    </div>
                    }
                </div>

            </div>
        </div>
    </div>
</ng-container>

<!-- Adjust / Void Dialog -->
<div class="filter-panel">
    <ng-template #purchaseAdjustVoidDialog let-cancel="cancel">
        <ppl-purchase-adjust-void-entry [purchaseData]="purchaseData" [searchParams]="appliedFilters"
            [actionData]="selectedAction" (purchaseAdjustedOrVoided)="purchaseAdjustedOrVoided($event)">
        </ppl-purchase-adjust-void-entry>
    </ng-template>
</div>

<!-- Search Filter Warning Dialog -->
<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p>
            At least one out of the following fields should be populated:
            Participant Name, Participant PPL ID.
        </p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'purchaseRequest'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<!-- View Purchase Request Dialog -->
<div class="filter-panel">
    <ng-template #viewPurchaseRequestDialog let-cancel="cancel">
        <ppl-create-purchase-request [mode]="mode" [purchaseRequestListData]="viewPurchaseRequestData"
            (cancel)="handleViewPurchaseRequestCancel($event)" [staffView]="true"></ppl-create-purchase-request>
    </ng-template>
</div>
